module.exports = __webpack_public_path__ + "img/1M.1.a2afc09d.jpg";